
import classes from './BackStep.module.scss';
import arrowRightBlue from '../../../../../../assets/icons/arrow-right-blue.svg';

declare function Translate(key: string): string;

const BackStep = props => {

    const onBackHandler = () => {
        props.prevStep(); 
    }
    
    const onBackPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){
          onBackHandler();
        }
    };

    return(
        <div className={classes.backStep}>
            <img src={arrowRightBlue} alt="" id='goBackImg' className={classes.goBackImg}  onClick={onBackHandler}/>
            <span aria-hidden="true">&nbsp;&nbsp;</span>                        
            <a id='goBackLink' 
            className={classes.backLink}
            onClick={onBackHandler}
            onKeyPress={onBackPress}
            tabIndex={0}               
            >
                {Translate('N_General_Back_Step')}
            </a>
        </div>
);
};
export default BackStep;